// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__1yIIv","title":"AfterImages45_title__15g_y","images":"AfterImages45_images__95fpE"};